import Vue from "vue";
import VueRouter from "vue-router";
/*import Home from "../views/Home.vue";
import About from "../views/AboutMe.vue";
import Contact from "../views/ContactMe.vue";
import Experiences from "../views/Experiences.vue";
import Game from "../views/Game.vue";
import Portfolio from "../views/Portfolio.vue";*/

Vue.use(VueRouter);

const Home = (resolve) => {
  require.ensure(["../views/Home.vue"], () => {
    resolve(require("../views/Home.vue"));
  });
};

const About = (resolve) => {
  require.ensure(["../views/AboutMe.vue"], () => {
    resolve(require("../views/AboutMe.vue"));
  });
};

const Contact = (resolve) => {
  require.ensure(["../views/ContactMe.vue"], () => {
    resolve(require("../views/ContactMe.vue"));
  });
};

const Experiences = (resolve) => {
  require.ensure(["../views/Experiences.vue"], () => {
    resolve(require("../views/Experiences.vue"));
  });
};

const Game = (resolve) => {
  require.ensure(["../views/Game.vue"], () => {
    resolve(require("../views/Game.vue"));
  });
};

const Portfolio = (resolve) => {
  require.ensure(["../views/Portfolio.vue"], () => {
    resolve(require("../views/Portfolio.vue"));
  });
};

export const routes = [
  {
    path: "/",
    name: "Home",
    number: 0,
    component: Home,
    beforeEnter: (to, from, next) => {
      console.log("ciaone");
      //console.log($route)
      console.log("ciaone");
      next();
    },
  },
  {
    path: "/about",
    name: "AboutMe",
    number: 1,
    component: About,
  },
  {
    path: "/contacts",
    name: "Contacts",
    component: Contact,
    number: 5,
  },
  {
    path: "/experiences",
    name: "Experiences",
    component: Experiences,
    number: 2,
  },
  {
    path: "/game",
    name: "Game",
    component: Game,
    number: 3,
  },
  {
    path: "/portfolio",
    name: "Portfolio",
    component: Portfolio,
    number: 4,
  },
];

const router = new VueRouter({
  routes,
});

export default router;
